import React, { useState, useRef } from "react";
import {
  Grid,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,

} from "@material-ui/core";
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';


import { useProfileContext, addDashboardGrades, firebaseUpload } from "../../context/ProfileContext";
import {Timestamp, firestore, storage, arrayUnion} from '../../firebase';

// styles
import useStyles from "./styles";

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Loading from "../../components/Loading/Loading";
import { FilterDramaTwoTone } from "@material-ui/icons";

export default function Dashboard(props) {
  var classes = useStyles();
  var Profile = useProfileContext().userInformation;
  var ProfileFileSystem = useProfileContext().files;
  var ProfileFileSystemUpdate = useProfileContext().setFiles;
  var ProfileContext = useProfileContext();
  var LoadingScreen = useProfileContext().Loading;
  const inputFile = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false)
  const [editScorecard, setEditScorecard] = useState(false);                                        
  const [scorecardForm, setScorecardForm] = useState({
    portfolioGrade: '',
    generationGrade: '',
    savingsGrade: '',                     
    assetsGrade: '',
    measurementGrade: '',                                            
  });

  const handleDialogOpen = () => {
    setDialogOpen(true);
  }

  const handleDialogClose = () => {
    setDialogOpen(false);
  }

  const handleChange = (e) => {
    const value = e.target.value;
    setScorecardForm({
      ...scorecardForm,                                                                                                                                         
      [e.target.name]: value
    })
  }

  const handleClick = () => {
    const {portfolioGrade, generationGrade, savingsGrade, assetsGrade, measurementGrade} = scorecardForm;
    const dashboardGrade = {
      portfolioGrade: portfolioGrade,
      generationGrade: generationGrade,
      savingsGrade: savingsGrade,
      assetsGrade: assetsGrade,
      measurementGrade: measurementGrade,
      updatedScorecard: Timestamp,
    }

    addDashboardGrades(dashboardGrade, ProfileContext, Profile);
    setEditScorecard(false);
    
  }

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if(file) firebaseUpload(file);
    ProfileFileSystemUpdate([...ProfileFileSystem, file.name]);
    console.log(ProfileFileSystem);
  };

  const firebaseDeleteFile = (fileName) => {
    let fileRef = storage.ref().child(localStorage.getItem('currentProfile') + '/' + fileName);
    fileRef
      .delete()
      .then(() => {
        // console.log('file deleted from storage');
        firestore
          .collection('Users')
          .doc(localStorage.getItem('currentProfile'))
          .update({
            fileSystem: arrayUnion.FieldValue.arrayRemove(fileName)
          })
          .then(() => {
            var newFileData = ProfileFileSystem.filter((item) => item !== fileName)
            ProfileFileSystemUpdate(newFileData);
            handleDialogClose();
          })
      })
  }

  if (LoadingScreen) {
    return(
    <Loading />
    )
  } 
  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          handleDialogClose();
          setSelectedFile(null);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure you would like to delete this file?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to delete "{selectedFile}". If you would like to go through with this action press "Delete" or else press "cancel".
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
              handleDialogClose();
              setSelectedFile(null);
            }} color="primary">
            Cancel
          </Button>
          <Button onClick={() => firebaseDeleteFile(selectedFile)} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <PageTitle title={Profile?.name} />
      <Grid container spacing={4}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget
            title='Basic Information'
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.performanceLegendWrapper}>
              <div className={classes.legendElement}>
                <Typography
                  color="text"
                  colorBrightness="secondary"
                >
                  Name: {Profile?.name} <br/>
                  Email: {Profile?.email} <br />
                  Completed Survey: {Profile?.surveyCompleted ? 'Yes' : 'No'}
                </Typography>
              </div>
            </div>
            <div className={classes.progressSection}>
              {Profile?.avatar ? 
              <Avatar src={'data:image/png;base64,' + Profile.avatar} className={classes.large} />
              : <Avatar className={classes.large} />}
            </div>
          </Widget>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget
            title='Scorecard'
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
            menuItems={true}
            menuItem1={true}
            menuItem1Name={'edit'}
            menuClick1={() => setEditScorecard(prevCheck => !prevCheck)}
          >
            <div className={classes.performanceLegendWrapper}>
              <div className={classes.legendElement}>
                {Profile?.dashboardGrade && !editScorecard ? (
                <Typography
                  color="text"
                  colorBrightness="secondary"
                >
                  Real Estate Portfolio Grade: {Profile?.dashboardGrade?.portfolioGrade} <br/>
                  Real Estate Portfolio Analysis for Earnings Generation: {Profile?.dashboardGrade?.generationGrade} <br />
                  Operating Expense & Occupancy Cost Savings: {Profile?.dashboardGrade?.savingsGrade} <br/>
                  Monetization of Excess Real Estate Assets: {Profile?.dashboardGrade?.assetsGrade} <br/>
                  IT Tools for Earnings Measurment: {Profile?.dashboardGrade?.measurementGrade} <br/>
                </Typography>
                ) :(
                <Typography
                color="text"
                colorBrightness="secondary"
                >
                  Real Estate Portfolio Grade:<br/>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="portfolioGrade">Portfolio Grade</InputLabel>
                      <Select name="portfolioGrade" value={scorecardForm.portfolioGrade} onChange={handleChange}>
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value='A+'>A+</MenuItem>
                        <MenuItem value='A'>A</MenuItem>
                        <MenuItem value='A-'>A-</MenuItem>
                        <MenuItem value='B+'>B+</MenuItem>
                        <MenuItem value='B'>B</MenuItem>
                        <MenuItem value='B-'>B-</MenuItem>
                        <MenuItem value='C+'>C+</MenuItem>
                        <MenuItem value='C'>C</MenuItem>
                        <MenuItem value='C-'>C-</MenuItem>
                      </Select>
                    </FormControl>  
                  <br/><br/>
                  Real Estate Portfolio Analysis for Earnings Generation:<br/>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="generationGrade">Generation Grade</InputLabel>
                      <Select name="generationGrade" value={scorecardForm.generationGrade} onChange={handleChange}>
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value='A+'>A+</MenuItem>
                        <MenuItem value='A'>A</MenuItem>
                        <MenuItem value='A-'>A-</MenuItem>
                        <MenuItem value='B+'>B+</MenuItem>
                        <MenuItem value='B'>B</MenuItem>
                        <MenuItem value='B-'>B-</MenuItem>
                        <MenuItem value='C+'>C+</MenuItem>
                        <MenuItem value='C'>C</MenuItem>
                        <MenuItem value='C-'>C-</MenuItem>
                      </Select>
                    </FormControl>  
                  <br /><br/>
                  Operating Expense & Occupancy Cost Savings:<br/>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="savingsGrade">Savings Grade</InputLabel>
                      <Select name="savingsGrade" value={scorecardForm.savingsGrade} onChange={handleChange}>
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value='A+'>A+</MenuItem>
                        <MenuItem value='A'>A</MenuItem>
                        <MenuItem value='A-'>A-</MenuItem>
                        <MenuItem value='B+'>B+</MenuItem>
                        <MenuItem value='B'>B</MenuItem>
                        <MenuItem value='B-'>B-</MenuItem>
                        <MenuItem value='C+'>C+</MenuItem>
                        <MenuItem value='C'>C</MenuItem>
                        <MenuItem value='C-'>C-</MenuItem>
                      </Select>
                    </FormControl> 
                  <br/><br/>
                  Monetization of Excess Real Estate Assets:<br/>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="assetsGrade">Assets Grade</InputLabel>
                      <Select name="assetsGrade" value={scorecardForm.assetsGrade} onChange={handleChange}>
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value='A+'>A+</MenuItem>
                        <MenuItem value='A'>A</MenuItem>
                        <MenuItem value='A-'>A-</MenuItem>
                        <MenuItem value='B+'>B+</MenuItem>
                        <MenuItem value='B'>B</MenuItem>
                        <MenuItem value='B-'>B-</MenuItem>
                        <MenuItem value='C+'>C+</MenuItem>
                        <MenuItem value='C'>C</MenuItem>
                        <MenuItem value='C-'>C-</MenuItem>
                      </Select>
                    </FormControl> 
                  <br/><br/>
                  IT Tools for Earnings Measurment: <br/>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="measurementGrade">Measurement Grade</InputLabel>
                      <Select name="measurementGrade" value={scorecardForm.measurementGrade} onChange={handleChange}>
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value='A+'>A+</MenuItem>
                        <MenuItem value='A'>A</MenuItem>
                        <MenuItem value='A-'>A-</MenuItem>
                        <MenuItem value='B+'>B+</MenuItem>
                        <MenuItem value='B'>B</MenuItem>
                        <MenuItem value='B-'>B-</MenuItem>
                        <MenuItem value='C+'>C+</MenuItem>
                        <MenuItem value='C'>C</MenuItem>
                        <MenuItem value='C-'>C-</MenuItem>
                      </Select>
                    </FormControl> 
                  <br/><br/>
                  <Button 
                    variant="contained" 
                    size="medium" 
                    color="Primary"
                    disabled={
                      scorecardForm.portfolioGrade.length > 0 && scorecardForm.generationGrade.length > 0 && scorecardForm.savingsGrade.length > 0
                      && scorecardForm.assetsGrade.length > 0 && scorecardForm.measurementGrade.length > 0 ? false : true
                    }
                    onClick={() => handleClick()}
                  >
                    Submit
                  </Button>
                </Typography>
                )}
              </div>
            </div>
            <div className={classes.progressSection}>
            </div>
          </Widget>
        </Grid>
        <Grid item xs={12}>
          <Widget
            title='Corp. RE Earnings Diagnostic - Questionnaire Answers'
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.performanceLegendWrapper}>
              <div className={classes.legendElement}>
                {Profile?.survey ? (
                <Typography
                  color="text"
                  colorBrightness="secondary"
                  wrap
                >
                  Email Address <br/> Answer: {Profile?.survey?.email} <br/><br/>
                  Name/Contact <br/> Answer: {Profile?.survey?.name} <br/><br/>
                  Company <br/> Answer: {Profile?.survey?.company} <br/><br/>
                  Sector/Industry <br/> Answer: {Profile?.survey?.industry} <br/><br/>
                  Phone <br/> Answer: {Profile?.survey?.phone} <br/><br/>
                  The corporate RE function has a clearly defined mission of contributing earnings to the enterprise? <br/> Answer: {Profile?.survey?.mission} <br/><br/>
                  There is untapped potential in the Company's RE assets for cost savings and new earnings. <br/> Answer: {Profile?.survey.potential} <br/><br/>
                  The Company is operating at a "best practices" level with respect to cost reduction strategies for real estate operating expenses and space utilization. <br/> Answer: {Profile?.survey?.bestPractices} <br/><br/>
                  The Company has established Key Performance Indicator's ("KPI's") for measuring RE's contribution to the success of the enterprise. <br/> Answer: {Profile?.survey?.kpi} <br/><br/>
                  The Company has a proactive strategy for disposition of excess property and leased space. <br/> Answer: {Profile?.survey?.disposition} <br/><br/>
                  The Company is aggressively executing the disposition process. <br/> Answer: {Profile?.survey?.aggressive} <br/><br/>
                  The company uses NRV (net realizable value) models that assist in space strategy and financial decision making. <br/> Answer: {Profile?.survey?.nrv} <br/><br/>
                  Does the Company's RE portfolio tie into the ERP system? <br/> Answer: {Profile?.survey?.erpSystem} <br/><br/>
                  The Company has the ability to breakout financials for RE occupancy costs. <br/> Answer: {Profile?.survey?.breakoutFinancials} <br/><br/>
                  If the Company runs SAP or Oracle - Is the RE module currently activated? <br/> Answer: {Profile?.survey?.REModule} <br/><br/>
                  What are the barriers to optimizing real estate assets in your enterprise? <br/> Answer: {Profile?.survey?.challenges} <br/><br/>
                </Typography>
                ) : (
                <Typography
                  color="text"
                  colorBrightness="secondary"
                  wrap
                >
                  Survey not completed yet
                </Typography>
                )}
              </div>
            </div>
            <div className={classes.progressSection}>
            </div>
          </Widget>
        </Grid>
        <Grid item xs={12}>
          <input
            style={{ display: "none" }}
            type="file"
            ref={inputFile}
            onChange={handleFileInput}
          />
          <Widget
            title="Files"
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
            menuItems={true}
            menuUpload={true}
            menuUploadName={'Upload'}
            editUploadClick={() => inputFile.current.click()}
          >
            {ProfileFileSystem?.length > 0 ? (
              <>
                {ProfileFileSystem.map((file) => {
                  return(
                    <ListItem 
                      button 
                      divider={true} 
                      ContainerComponent="div" 
                      className={classes.listItem} 
                      onClick={() => {
                        console.log(file);
                        localStorage.setItem('file', file);
                        props.history.push(`/app/${localStorage.getItem('currentProfile')}/profile/${file}`)
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar>
                          <FolderIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={file}
                      />
                      <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete" onClick={() => {
                          handleDialogOpen();
                          setSelectedFile(file);
                        }}>
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
              </>
            ) : (
              <Typography
                  color="text"
                  colorBrightness="secondary"
                >
                  No files available 
              </Typography>
            )}
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
